import { getErrorToast, getErrorMessage } from '@utils';
import {
  GET_SUBLINE_ITEM_DETAILS,
  GET_SUBLINE_ITEM_TRANSACTIONS,
  SET_SUBLINE_ITEM_TRANSACTIONS_LOADING,
  GET_SUBLINE_ITEM_PARTS,
  SET_SUBLINE_ITEM_PARTS_LOADING,
  SET_SUBLINE_ITEM_PARTS_ERROR,
  GET_SUBLINE_ITEM_EXPLODED_VIEW,
  SET_SUBLINE_ITEM_EXPLODED_VIEW_LOADING,
  SET_SUBLINE_ITEM_EXPLODED_VIEW_ERROR,
  GET_HISTORY,
  SET_HISTORY_LOADING,
  SET_HISTORY_ERROR,
  SET_TOAST,
  TOGGLE_PAGE_ERROR,
  RESET_SUBLINE_ITEM,
  GET_ATTACHMENTS
} from '../types';

/* eslint-disable no-unused-vars */

export const getSublineItemDetails =
  (sublineItemId) =>
  async (dispatch, _getState, { api }) => {
    try {
      const res = await api.get(`/inventory/subline-item/${sublineItemId}`);

      if (!res.data) {
        throw new Error('Subline Item does not exist.');
      }

      dispatch({
        type: GET_SUBLINE_ITEM_DETAILS,
        payload: res.data
      });
    } catch (e) {
      dispatch({
        type: SET_TOAST,
        payload: getErrorToast({
          body: getErrorMessage(e)
        })
      });

      dispatch({
        type: TOGGLE_PAGE_ERROR,
        payload: true
      });
    }
  };

export const getSublineItemHistory =
  (sublineItemId) =>
  async (dispatch, _getState, { pnetApi }) => {
    try {
      dispatch({
        type: SET_HISTORY_LOADING,
        payload: true
      });

      const res = await pnetApi.get(
        `/api/logger/subline-item/${sublineItemId}`
      );

      // An unrouted /api/logger/ answers 200 with the PartnerNet HTML page.
      if (!Array.isArray(res.data)) {
        throw new Error('History response was not a list.');
      }

      dispatch({
        type: GET_HISTORY,
        payload: res.data
      });
    } catch (e) {
      dispatch({
        type: SET_HISTORY_ERROR,
        payload: getErrorMessage(e)
      });
    }
  };

export const getSublineItemTransactions =
  (sublineItemId) =>
  async (dispatch, _getState, { api }) => {
    try {
      dispatch({
        type: SET_SUBLINE_ITEM_TRANSACTIONS_LOADING,
        payload: true
      });

      const res = await api.get(`/subline-items/${sublineItemId}/transactions`);

      dispatch({
        type: GET_SUBLINE_ITEM_TRANSACTIONS,
        payload: res.data
      });
    } catch (e) {
      dispatch({
        type: SET_SUBLINE_ITEM_TRANSACTIONS_LOADING,
        payload: false
      });
      dispatch({
        type: SET_TOAST,
        payload: getErrorToast({
          body: getErrorMessage(e)
        })
      });
    }
  };

export const getSublineItemParts =
  (sublineItemId) =>
  async (dispatch, _getState, { api }) => {
    try {
      dispatch({
        type: SET_SUBLINE_ITEM_PARTS_LOADING,
        payload: true
      });
      const res = await api.get(`/subline-items/${sublineItemId}/parts`);
      dispatch({ type: GET_SUBLINE_ITEM_PARTS, payload: res.data });
    } catch (e) {
      dispatch({
        type: SET_SUBLINE_ITEM_PARTS_ERROR,
        payload: getErrorMessage(e)
      });
    }
  };

// Exploded views imported through IMS are PartnerNet attachments on the
// inventory item; the attachments endpoint returns their presigned urls.
export const getSublineItemExplodedView =
  (inventoryItemId) =>
  async (dispatch, _getState, { api }) => {
    dispatch({ type: SET_SUBLINE_ITEM_EXPLODED_VIEW_LOADING });
    try {
      const res = await api.get(
        `/attachments/inventory_item/${inventoryItemId}`
      );
      dispatch({
        type: GET_SUBLINE_ITEM_EXPLODED_VIEW,
        payload: Array.isArray(res.data) ? res.data : []
      });
    } catch (e) {
      dispatch({
        type: SET_SUBLINE_ITEM_EXPLODED_VIEW_ERROR,
        payload: getErrorMessage(e)
      });
    }
  };

export const resetSublineItemDetails = () => async (dispatch) => {
  try {
    dispatch({
      type: RESET_SUBLINE_ITEM
    });

    dispatch({
      type: GET_ATTACHMENTS,
      payload: []
    });
  } catch (e) {
    dispatch({
      type: SET_TOAST,
      payload: getErrorToast({
        body: getErrorMessage(e)
      })
    });
  }
};
